export const SVS = "SVS";
export const DOC = "DOC";
export const MICRODEPOSIT = "MICRODEPOSIT";
export const AIS = "AIS";
export const AVS = "AVS";
export const LOADING = "LOADING";
export const CONFIRMATION = "CONFIRMATION";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const AWAITING_REDIRECT = "AWAITING_REDIRECT";

export const AIS_SUCCESS = "AIS_SUCCESS";
export const AIS_FAILURE = "AIS_FAILURE";
export const AIS_CONSENT_INITIALIZED = "AIS_CONSENT_INITIALIZED";
export const AIS_COMPONENT_TIMEOUT = "AIS_COMPONENT_TIMEOUT";

